module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp2_9006.142878e8.png";